import { SVGProps } from 'react';

export const CategoryPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26191 11.2381H8.88095C9.17062 11.2381 9.40476 11.004 9.40476 10.7143V8.61909C9.40476 8.32942 9.17062 8.09528 8.88095 8.09528H6.78571C6.49605 8.09528 6.26191 8.32942 6.26191 8.61909V9.1429C4.16667 9.1429 2.62824 7.53899 2.59524 5.47623H3.11905C3.40871 5.47623 3.64286 5.24209 3.64286 4.95242V2.85718C3.64286 2.56752 3.40871 2.33337 3.11905 2.33337H1.02381C0.734143 2.33337 0.5 2.56752 0.5 2.85718V5.47623C0.5 8.65837 3.07976 11.2381 6.26191 11.2381Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.61894 3.64292C9.41337 3.64292 10.0594 2.99686 10.0594 2.20244C10.0594 1.40802 9.41337 0.761963 8.61894 0.761963C7.82452 0.761963 7.17847 1.40802 7.17847 2.20244C7.17847 2.99686 7.82452 3.64292 8.61894 3.64292Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.61899 4.00305C6.92283 4.00305 5.73804 4.89147 5.73804 6.16377V6.52389H11.4999V6.16377C11.4999 4.89147 10.3152 4.00305 8.61899 4.00305Z"
      fill="currentColor"
    />
  </svg>
);
